import ChooseLevelScreen from "./chooseLevel";
import StartLevelScreen from "./start";
import ChooseFigureScreen from "./chooseFigure";
import TestScreen from "./test";
import GameScreen from "./game";
import GameOverScreen from "./gameOver";
import EditorScreen from "./editor";
import SurveyScreen from "./survey";
export default {
  chooseLevel: ChooseLevelScreen,
  test: TestScreen,
  start: StartLevelScreen,
  chooseFigure: ChooseFigureScreen,
  survey: SurveyScreen,
  game: GameScreen,
  gameOver: GameOverScreen,
  editor: EditorScreen
};